import { User } from "models/user";
import { Score } from "types/assessments";
import { Document } from "@contentful/rich-text-types";
import { Scores } from "models/score";
import { SubFactor } from "models/bhi";

export enum UserAssessmentCycleStatus {
  IN_PROGRESS = "assessments_in_progress",
  NOT_STARTED = "assessments_not_started",
  READY_FOR_REVIEW = "ready_for_review",
  READY_TO_SCORE = "ready_to_score",
  SCORE_FINALIZED = "score_finalized",
  SCORING_IN_PROGRESS = "scoring_in_progress"
}

export interface PillarScore {
  id?: string;
  pillarName: string;
  value: number;
  userAssessmentCycleId?: string;
  userAssessments: Partial<UserAssessment>[] | null;
}

interface UserAssessment {
  id: string;
  name: string;
  userId: string;
  user: User;
  assessmentId: string;
  assessment: Partial<any>;
  assessmentScore: number;
  assessmentCompletionDate: string;
  lastAssessment: boolean;
  userAnswers: any[];
  completed: boolean;
  timeToComplete: number;
  order: number;
  preambleText: string;
  preambleImage: string;
  videoUrl?: string;
  timeLabel?: string;
  preambleImageAltText: string;
  displayName: string;
  scores: Score[];
}

export interface GetSessionsData {
  participantAssessmentCycles: AssessmentCycle[];
}

export interface SelectedSubFactor extends SubFactor {
  index: number;
}
export interface AssessmentCycle {
  coachingSessions: CoachingSession[];
  imagingSessions: ImagingSession[];
}
export interface CoachingSession {
  id: string;
  coach: {
    firstName: string;
  };
  status: CoachingSessionStatus;
  acuityConfirmationNumber: number;
  sessionTime: string;
  updatedAt: string;
  participantNotes: string | null;
  reflectionSurvey: {
    completionDate: string | null;
    dismissalDate: string | null;
    answers: {
      answerData: {
        response: string;
      };
    }[];
  } | null;
}

export interface ImagingSession {
  id: string;
  status: CoachingSessionStatus;
  acuityConfirmationNumber: number;
  sessionTime: string;
  updatedAt: string;
  participantNotes: string | null;
}

export enum CoachingSessionStatus {
  SCHEDULED = "scheduled",
  COMPLETED = "completed",
  CANCEL = "cancel",
  MISSED = "missed"
}

export enum SessionType {
  COACHING = "coaching",
  IMAGING = "imaging",
  GROUP = "group"
}
export interface Cycle {
  status: UserAssessmentCycleStatus;
  cycleNumber: number;
  cycleCompletionDate: string;
  notes: string;
  pillarScores: PillarScore[];
  coachingSessions: CoachingSession[];
  imagingSessions: ImagingSession[];
}

export interface Pillar {
  color: string;
  description: string;
  pillarName: string;
  value: number;
  order: number;
  weight: number;
  index?: number;
  assessments: PillarAssessment[];
  moreInfo: Record<any, any>[];
}

export interface PillarAssessment {
  name: string;
  score: number;
  description: string;
}
